// extracted by mini-css-extract-plugin
export default {"dropArea":"FileInput_dropArea__JO5q6","dropAreaChildren":"FileInput_dropAreaChildren__JaZCc","text":"FileInput_text__XakV6","tint":"FileInput_tint__x1JKF"};